import React from 'react';
import AttritionReportPicker from './components/AttritionReportPicker';

function AdminAttritionReport() {
  return (
    <div style={{ padding: 24 }}>
      <AttritionReportPicker
        companiesApiPath="/api/admin/attrition-report/companies"
        reportApiPath="/api/admin/attrition-report"
        tokenKey="gogig_admin_access"
        title="Employee Attrition Report"
        subtitle="Companies with stipend CSV for the selected year. Attrition matches candidates by mobile (same / joined / left). Slips are not used."
        redirectOnAuthFailure={false}
      />
    </div>
  );
}

export default AdminAttritionReport;
